var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.5665 7.15005V12.85C17.5665 13.7834 17.0665 14.6501 16.2582 15.1251L11.3082 17.9834C10.4998 18.4501 9.49981 18.4501 8.68315 17.9834L3.73314 15.1251C2.92481 14.6584 2.4248 13.7917 2.4248 12.85V7.15005C2.4248 6.21672 2.92481 5.35001 3.73314 4.87501L8.68315 2.01669C9.49148 1.55002 10.4915 1.55002 11.3082 2.01669L16.2582 4.87501C17.0665 5.35001 17.5665 6.20838 17.5665 7.15005Z",
    fill: "#FF403D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.4583C9.65833 11.4583 9.375 11.175 9.375 10.8333V6.45831C9.375 6.11665 9.65833 5.83331 10 5.83331C10.3417 5.83331 10.625 6.11665 10.625 6.45831V10.8333C10.625 11.175 10.3417 11.4583 10 11.4583Z",
    fill: "#FF403D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 14.375C9.89199 14.375 9.78365 14.3499 9.68365 14.3083C9.57532 14.2666 9.49197 14.2083 9.40864 14.1333C9.33364 14.05 9.27533 13.9583 9.22533 13.8583C9.18366 13.7583 9.16699 13.65 9.16699 13.5416C9.16699 13.325 9.25031 13.1083 9.40864 12.9499C9.49197 12.8749 9.57532 12.8166 9.68365 12.775C9.99199 12.6416 10.3587 12.7166 10.592 12.9499C10.667 13.0333 10.7253 13.1166 10.767 13.225C10.8086 13.325 10.8337 13.4333 10.8337 13.5416C10.8337 13.65 10.8086 13.7583 10.767 13.8583C10.7253 13.9583 10.667 14.05 10.592 14.1333C10.4337 14.2916 10.2253 14.375 10.0003 14.375Z",
    fill: "#FF403D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError2);
export default __webpack_public_path__ + "static/media/error-2.f33778f21c0bf005422689c940d24348.svg";
export { ForwardRef as ReactComponent };